import FooterMobileMenu from './FooterMobileMenu';
export default FooterMobileMenu;
